import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const WHACK_A_MOLE_ACTIVITY_FRAGMENT = gql `
  fragment WhackAMoleActivityFragment on WhackAMoleActivity {
    rounds {
      id
      numTimesShuffled
      sentence
      syllableGroups
      syllables
      answer
      answerAudio {
        id
        audio {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default WHACK_A_MOLE_ACTIVITY_FRAGMENT;
